
import Form from "./Form.vue";

export default {
  name: "app-lista-preco-servico-create",
  components: {
    Form,
  },
};
